/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';

import VideosAdminPermissionsFormContainer from '../containers/videosAdminPermissionsFormContainer';

import styles from '../styles/videosAdminPermissions.module.scss';

const VideosAdminPermissions = ({ isTopicPermissions = false, permissions, permissionsKey, schemaModules }) =>
  permissions.isLoading || permissions.isFetching ? (
    <Loading className={styles.loader} />
  ) : (
    <section className={styles.element}>
      {schemaModules?.map((module) => (
        <VideosAdminPermissionsFormContainer
          key={module}
          module={module}
          isTopicPermissions={isTopicPermissions}
          permissions={permissions}
          permissionsKey={permissionsKey}
        />
      ))}
    </section>
  );

VideosAdminPermissions.propTypes = {
  isTopicPermissions: PropTypes.bool,
  permissions: PropTypes.shape({}).isRequired,
  permissionsKey: PropTypes.arrayOf(PropTypes.string).isRequired,
  schemaModules: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default React.memo(VideosAdminPermissions);
